<chr-icon [name]="chevronIcon()" />

<span>{{ filter().label }}</span>

@if (selectedValues().size) {
  <chr-pill palette="accent" size="l" [value]="selectedValues().size" variant="secondary" />
}
